/* projects/wtaf/src/app/features/widgets/brand-scheduler-report-widget/brand-scheduler-report-widget.component.css */
.widget-subtitle {
  font-size: 12px;
  color: #6c757d;
}
.filter-label {
  font-size: 12px;
  font-weight: 600;
  color: #343a40;
  margin-bottom: 4px;
}
.error-msg {
  color: #db3b21;
  font-size: 13px;
  font-weight: 500;
}
.no-record {
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  padding: 10px;
}
.pass-text {
  color: #1aaa55;
  font-weight: 600;
}
.fail-text {
  color: #db3b21;
  font-weight: 600;
}
.skip-text {
  color: #5b54c7;
  font-weight: 600;
}
/*# sourceMappingURL=brand-scheduler-report-widget.component.css.map */
